
import React from 'react';
import ApplicationLayout from '../../layouts/ApplicationLayout';
import Ax from '../../components/hoc/Ax';
import TappetLogo from '../../assets/img/svg/logo_new.svg';
import indiaLogo from '../../assets/img/indianflag.png';
import diwaliLogo from '../../assets/img/diwali.png';
import holiLogo from '../../assets/img/holi.png';



import AdminAvatar from '../../assets/img/admin_logo.png';
import { Link } from 'react-router-dom';
import './ApplicationHeader.css';
import { connect } from 'react-redux';
import TapSelect from '../../components/ui/TapSelect';
import UserSvg from '../../assets/img/svg/user.svg';
import DropDownIcon from '../../assets/img/svg/arrow-dropdown.svg';
import SearchIcon from '../../assets/img/svg/search-icon.svg';
import UserSvg2 from '../../assets/img/svg/User_icon_2.svg';
import { Collapse, Modal } from "bootstrap";
import FeedbackModal from "../../layouts/modal/FeedbackModal";
import TapIcon from '../../services/TapIcon';
import * as actions from '../../store/actions/index';
import FuelReceive from '../groupData/fuelStation/FuelReceive';
import FuelIssued from '../groupData/fuelStation/FuelIssued';
import FuelTransfer from '../groupData/fuelStation/FuelTransfer';
import InputAssetSearch from './ui/InputAssetSearch';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import CommonSearch from './CommonSearch';
import AllNotifications from './AllNotifications';
import { ORG_API_BASE_URL_2 } from '../../services/TapApiUrls';
import HttpAPICall from '../../services/HttpAPICall';
import {fetchNotifications, getCachedData } from '../../services/NotificationData';


class ApplicationHeader extends React.Component {

    constructor() {
        super();
        this.state = {
            userDropdown: true,
            showModalNew: false,
            openQuickNavigation: false,
            showNotifications: false,
            unreadCount: 0,
            isLoadingNotifications: false,

        };
        this.wrapperRef = React.createRef();

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.logFuelReceiveRef = React.createRef();
        this.logFuelIssuedRef = React.createRef()
        this.logFuelTransferRef = React.createRef()
    }

    addFeedbackModalInit = () => {
        this.setState({ showModalNew: true });
    }
 
    closeModal = () => {
        this.setState({ showModalNew: false });
    }
   toggleNotification = () => {
    if (this.state.isLoadingNotifications) return;
    
    this.setState(prev => ({
        showNotifications: !prev.showNotifications
    }));
};


    updateUnreadCount = (count) => {
        this.setState({ unreadCount: count });
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        const { access_token } = this.props;
        if (access_token) {
            const cached = getCachedData();
            this.setState({ unreadCount: cached.unreadCount });
            if (!cached.isFetched) {
                this.setState({ isLoadingNotifications: true });
                fetchNotifications(access_token, (notifications, count) => {
                    this.setState({
                        unreadCount: count,
                        isLoadingNotifications: false
                    });
                }, false);
            }
        }
    }


    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
  
    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ openQuickNavigation: false })
        }
    }

    openQuickNavigation = () => {
        var isShown = document.getElementById('quick').classList.contains('show');
        if (isShown == true) {
            this.setState({ openQuickNavigation: true })
        } else {
            this.setState({ openQuickNavigation: false })
        }
    }

    clearCacheDataHandler = () => {
        this.clearLocalStorageHandler()
        this.props.clearAppData();
        window.location.reload();
    }

    clearLocalStorageHandler = () => {
        localStorage.removeItem('assetStatusWidget');
        localStorage.removeItem('transactionDelayWidget');
        localStorage.removeItem('scsWidget');
        localStorage.removeItem('rentalStatusWidget');
        localStorage.removeItem('rentalDueDateWidget');
        localStorage.removeItem('counterlogAgeingWidget');
        localStorage.removeItem('ticketWidget');
        localStorage.removeItem('PUCWidget');
        localStorage.removeItem('requistionWidget');
        localStorage.removeItem('purchaseOrderWidget');
        localStorage.removeItem('complianceWidget');
        localStorage.removeItem('walletWidget');
        localStorage.removeItem('fuelSummaryWidget');
        localStorage.removeItem('releasesList');
        localStorage.removeItem('indentAgeingWidget');
        localStorage.removeItem('requistionAgeingWidget');
        localStorage.removeItem('poAgeingWidget');
        localStorage.removeItem('EmployeeComplianceWidget');
        localStorage.removeItem('stockMovementWarehouseWidget');
        localStorage.removeItem('fuelConsumptionWidget');
        localStorage.removeItem('productivityWidget');
        localStorage.removeItem('taskActivity');
        localStorage.removeItem('segregationWidget');
        localStorage.removeItem('hgSaptaskActivity');
        localStorage.removeItem('SiteProductivityWidget');
        localStorage.removeItem('SiteProductivityTargetWidget');
    }

    receiveModalInit = () => {

        this.logFuelReceiveRef.current.fuelReceiveModalInit()
    }

    fuelIssuedModalInit = (id) => {
        this.logFuelIssuedRef.current.issuedFuelModalInit()
    }

    fuelTransferModalInit = (id) => {
        this.logFuelTransferRef.current.transferFuelModalInit()

    }
    

    render() {
        let wallet_permission = this.props.permissions.group_sub_modules.find(s => s.sub_module == "iam-wallet")

        let { group_info } = { ...this.props }

        let logo = (group_info && group_info.activate_group_logo == 'Y' && group_info.image_path)
            ? this.props.group_info.image_path
            : TappetLogo;

        return (
            <Ax>
                <div className="app__header container-fluid bg-white " >
                    <nav className="  navbar navbar-expand-lg navbar-light bg-white  mainNavbar">
                        <Link to="/my_dashboard" className="app-header_logo">
                            <img src={logo} className="logo-img" alt="TappetBox" />
                            {/* <img src={holiLogo} style={{maxHeight:"63px !important", marginTop: "-10px"}} alt="TappetBox" className='ms-2' />  */}
                            {/* <img src={diwaliLogo} style={{maxHeight:"50px", marginTop: "-10px", marginLeft: "10px"}} alt="Happy Diwali" className='ms-4' /> */}
                            {/* <img src={indiaLogo} style={{maxHeight:"50px", marginTop: "-10px"}} alt="TappetBox" className='ms-2' /> */}
                        </Link>
                        <button className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#mainNavbar"
                            aria-controls="mainNavbar"
                            aria-expanded="false"
                            aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse justify-content-end" id="mainNavbar">

                            <ul className="nav justify-content-center " >
                                <CommonSearch className="common-search-wrapper" />
                                <li className="nav-item mt-1 pt-1 ps-3">
                                    <span
                                        role="button"
                                        className="nav-link position-relative"
                                        style={{ padding: "10px 15px 0px 15px" }}
                                        onClick={this.toggleNotification}
                                    >
                                        <TapIcon.FontAwesomeIcon
                                            icon={TapIcon.faBell}
                                            style={{ height: "24px", width: "24px", color: "#45BEA4" }}
                                        />
                                        {this.state.unreadCount > 0 && (
                                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                                style={{ fontSize: "10px", marginTop: "5px", marginLeft: "-15px" }}>
                                                {this.state.unreadCount > 9 ? '9+' : this.state.unreadCount}
                                            </span>
                                        )}
                                    </span>
                                </li>
                                <li className="nav-item " ref={this.wrapperRef}>
                                    <a role="button" className="nav-link " id="quick" style={{ 'padding': '10px 15px 0px 15px' }} onClick={this.openQuickNavigation} data-bs-toggle="dropdown" href="#" aria-expanded="false" >
                                        {this.state.openQuickNavigation == false ? <TapIcon.FontAwesomeIcon icon={TapIcon.faTimesCircle} className="rotate" style={{ 'height': '35px', width: "25px" }} color={"#45BEA4"} />
                                       : <TapIcon.FontAwesomeIcon icon={TapIcon.faTimesCircle} style={{ 'height': '35px', width: "25px" }} color={"#45BEA4"} />}
                                    </a>

                                    <ul className="dropdown-menu dropdown-menu-end">
                                        <li>
                                            <div className="row" style={{ maxHeight: "450px", overflow: "auto" }}>
                                                 {!this.props.permissions.group_modules.includes("isc") ? null : (
                                                    <ul className="list-unstyled col-sm mr0 pr0">
                                                        <li className="dropdown-header ">Inventory</li>
                                                        {this.props.permissions.permissions.includes("isc-item-add") && <Link to={'/item_list/add_item'}><li className='dropdown-item'>+ Item</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc-warehouse-indent-add") && <Link to={'/warehouse_indent_add'}><li className='dropdown-item'>+ Warehouse Indent</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc-purchase-requisition-add") && <Link to={'/requisition_list/add'}> <li className='dropdown-item'>+ Purchase Requisition</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc-po-add") && <Link to={'/purchase_order/add'}><li className='dropdown-item'>+ Purchase Order</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc-purchase-add") && <Link to={'/purchase_list/add'}><li className='dropdown-item'>+ Purchase</li></Link>}
                                                        {this.props.permissions.permissions.includes("/item_demand_add") && <Link to={'/item_demand_add'}><li className='dropdown-item'>+ Item Demand</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc-allocation-add") && <Link to={'/allocation_list/add'}><li className='dropdown-item'>+ Allocation</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc-consumption-add") && <Link to={'/consumption_list/add'}> <li className='dropdown-item'>+ Consumption</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc_item_demand_add") && <Link to={'/item_demand_add'}> <li className='dropdown-item'>+ Demand</li></Link>}
                                                        {this.props.permissions.permissions.includes('logistic_add') && <Link to={'/logistic_add'}> <li className='dropdown-item'>+ Logistic</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc-item-opening-balance") && <Link to={'/item_opening_balance/add'}><li className='dropdown-item'>+ Opening Balance</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc-inventory_transfer-add") && <Link to={'/inventory_transfer_list/add'}><li className='dropdown-item'>+ Inventory Transfer</li></Link>}
                                                        {this.props.permissions.permissions.includes("isc-inventory-adjustment-add") && <Link to={'/inventory_adjustment_add'}><li className='dropdown-item'>+ Inventory Adjustment</li></Link>}
                                                    </ul>)}
                                                <ul className="list-unstyled col-sm mr0 pr0">
                                                    <li className="dropdown-header ">Group Data</li>
                                                    <Link to={'/customer/add'}><li className='dropdown-item'>+ Customer</li></Link>
                                                    <Link to={'/fuelstation_add'}><li className='dropdown-item'>+ Fuel Station</li></Link>
                                                    <Link to={'/sites'}><li className='dropdown-item'>+ Site</li></Link>

                                                    {this.props.permissions.permissions.includes("iam-sub-assembly-add") && <Link to={'/sub_assembly_add'}><li className='dropdown-item'>+ Sub-Assembly</li></Link>}
                                                    {this.props.permissions.permissions.includes("grp-user-add") && <Link to={'/user_add'}><li className='dropdown-item'>+ User</li></Link>}
                                                    {this.props.permissions.permissions.includes("vendor-add") && <Link to={'/vendor/add'}><li className='dropdown-item'>+ Vendor</li></Link>}
                                                    <Link to={'/warehouse/add'}><li className='dropdown-item'>+ Warehouse</li></Link>
                                                    
                                                 
                                                    {this.props.permissions.permissions.includes("iam-workstation-add") && <Link to={'/workstation_add'}><li className='dropdown-item'>+ WorkStation</li></Link>}

                                                </ul>
                                                <ul className="list-unstyled col-sm">
                                                    <li className="dropdown-header ">Fuel Station</li>
                                                    <li>   <a role="button"
                                                        onClick={() => {
                                                            if (this.props?.permissions?.permissions?.includes('iam-fuel-station-fuel-receive')) {
                                                                return this.receiveModalInit()
                                                            }
                                                        }}
                                                        className={['dropdown-item', this.props?.permissions?.permissions?.includes('iam-fuel-station-fuel-receive') ? '' : 'disabled'].join(' ')}
                                                        title={!this.props?.permissions?.permissions?.includes('iam-fuel-station-fuel-receive') ? 'You do not have permission to perform this action' : ''}
                                                        style={{ "pointerEvents": "all" }}
                                                    >+ Received Fuel</a></li>
                                                    <li>   <a role="button"
                                                        onClick={() => {
                                                            if (this.props?.permissions?.permissions?.includes('iam-fuel-station-fuel-issue')) {
                                                                return this.fuelIssuedModalInit()
                                                            }
                                                        }}
                                                        className={['dropdown-item', this.props?.permissions?.permissions?.includes('iam-fuel-station-fuel-issue') ? '' : 'disabled'].join(' ')}
                                                        title={!this.props?.permissions?.permissions?.includes('iam-fuel-station-fuel-issue') ? 'You do not have permission to perform this action' : ''}
                                                        style={{ "pointerEvents": "all" }}
                                                    >+ Issue Fuel</a></li>
                                                    <li>   <a role="button"
                                                        onClick={() => {
                                                            if (this.props?.permissions?.permissions?.includes('iam-fuel-station-fuel-transfer')) {
                                                                return this.fuelTransferModalInit()
                                                            }
                                                        }}
                                                        className={['dropdown-item', this.props?.permissions?.permissions?.includes('iam-fuel-station-fuel-transfer') ? '' : 'disabled'].join(' ')}
                                                        title={!this.props?.permissions?.permissions?.includes('iam-fuel-station-fuel-transfer') ? 'You do not have permission to perform this action' : ''}
                                                        style={{ "pointerEvents": "all" }}
                                                    >+ Fuel Transfer To Station</a></li>
                                                    {!this.props.permissions.group_modules.includes("hrm") ? null : (
                                                        <ul className="list-unstyled col-sm mr0 pr0">
                                                            <li className="dropdown-header mt-5 ">HR Module</li>
                                                            {this.props.permissions.permissions.includes("hrm-employee-add") && <Link to={'/employee_add'}><li className='dropdown-item'>+ Employee</li></Link>}
                                                            {!this.props.permissions.permissions.includes("hrm") && <Link to={'/hrm/daily_attendance'}><li className='dropdown-item'>+ Daily Attendence</li></Link>}
                                                        </ul>)}
                                                </ul>
                                                <ul className={!wallet_permission ? "list-unstyled col-sm  ml0  pl0" : "list-unstyled col-sm"}>
                                                    <li className="dropdown-header">Asset</li>
                                                    <Link to={'/daily_counterlog'}> <li className='dropdown-item'>+ Logsheet</li></Link>
                                                    <Link to={'/ticket/add'}> <li className='dropdown-item'>+ Ticket</li></Link>
                                                    {this.props.permissions.permissions.includes("site-productivity-add") && <Link to={'/site_productivity/add'}><li className='dropdown-item'>+ Site Productivity</li></Link>}
                                                </ul>
                                                {!wallet_permission ? null
                                                    : (<ul className="list-unstyled col-sm ml0 pl0">
                                                        <li className="dropdown-header">Accounts Module</li>
                                                        <Link to={'/wallet/add'}><li className='dropdown-item'>+ Wallet</li></Link>
                                                        <Link to={'/wallet/fund-transfer'}><li className='dropdown-item'>+ Fund Transfer</li></Link>
                                                        <Link to={'/report/asset_invoice_calculator'}><li className='dropdown-item'>+ Invoice Calculation</li></Link>
                                                    </ul>)}
                                            </div>
                                        </li>
                                    </ul>


                                     </li>
                                <li className="nav-item ">

                                     <a className="nav-link dropdown-toggle" style={{ 'padding': '10px 15px 0px 15px' }} data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">
                                        <img src={AdminAvatar} style={{ 'height': '39px' }} className="avatar rounded-circle" alt={this.props.user_name} />
                                    </a>

                                    <ul className="dropdown-menu  cursor_pointer" style={{ left: "auto", right: "30px" }} >
                                        <li className="dropdown-item">{this.props.user_name}</li>
                                        <li className="dropdown-item" onClick={() => this.addFeedbackModalInit()}>Feedback</li>
                                        <li><Link title='Clear Cache & Data' className="dropdown-item" onClick={() => this.clearCacheDataHandler()}>Refresh</Link></li>
                                        <li><Link className="dropdown-item" to="/my_profile">My Profile</Link></li>
                                        <li><Link className="dropdown-item" to="/logout">Logout</Link></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </nav>

                  {this.state.showModalNew === true ? <FeedbackModal close={this.closeModal} /> : null}
                    <FuelReceive ref={this.logFuelReceiveRef} />
                    <FuelIssued ref={this.logFuelIssuedRef} />
                    <FuelTransfer ref={this.logFuelTransferRef} />
                    {this.state.showNotifications && (
                        <AllNotifications
                            open={this.state.showNotifications}
                            onClose={this.toggleNotification}
                            updateUnreadCount={this.updateUnreadCount}
                        />
                    )}
                </div>
            </Ax>
        )
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        user_name: state.app.user_info?.name ?? '',
        group_info: state.app.group_info,
        permissions: state.app && state.app.acl_info ? state.app.acl_info : null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        clearAppData: () => dispatch(actions.clearAppData())
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ApplicationHeader));